import React, { useState, useEffect } from "react";
import Flex from "@react-css/flex";
import Modal from "react-modal";
import { StyledForm } from "../../styled-components/StyledForm.style";
import { StyledModalCicloAdd } from "../../styled-components/StyledModalCicloAdd.style";
import { DynamicInputPME } from "../DynamicInputPME";
import api from "../../services/api";
import Swal from "sweetalert2";

const MemorizedDynamicInput = React.memo(DynamicInputPME);

export const ModalImportPMEMultiplicadores = ({
  isOpen,
  modalData,
  onAfterOpen,
  onRequestClose,
}) => {
  const [listaMultiplicadoresData, setListaMultiplicadoresData] = useState([]);
  const [perfilNome, setPerfilNome] = useState("");

  const config = {
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Credentials": false,
    },
  };

  // Função para buscar os dados da tabela
  const getPerfilTabela = async () => {
    try {
      const response = await api.get(
        `PmePerfil/${modalData.idPerfil}/${modalData.idPrograma}`,
        config
      );
      setListaMultiplicadoresData(response.data?.data || []);
      console.log("Dados da tabela de multiplicadores:", response.data?.data);
    } catch (err) {
      console.error("Erro ao buscar tabela de multiplicadores:", err);
    }
  };

  // Função para buscar o nome do perfil
  const getPerfil = async () => {
    try {
      const response = await api.get(`PmePerfil/${modalData.idPerfil}`, config);
      setPerfilNome(response.data?.data?.nome || "");
    } catch (err) {
      console.error("Erro ao buscar perfil:", err);
    }
  };

  // Atualizar estado ao alterar um campo
  const handleInputChange = (id, field, value) => {
    setListaMultiplicadoresData((prev) =>
      prev.map((item) =>
        item.idPerfilsProgramasMultiplicadores === id
          ? { ...item, [field]: parseFloat(value) || 0 }
          : item
      )
    );
  };

  // Atualizar dados ao abrir o modal
  useEffect(() => {
    const fetchData = async () => {
      if (isOpen) {
        await getPerfilTabela();
        await getPerfil();
      }
    };
    fetchData();
  }, [isOpen]);

  const style = {
    content: {
      top: "45%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      borderRadius: "0px",
      minWidth: "50%",
      overflowY: "auto",
      minHeight: "calc(0vh - 250px)",
      maxHeight: "calc(100vh - 250px)",
    },
        overlay: {
            zIndex: 9999
        }
  };

  const saveTable = async () => {
    console.log('listaMultiplicadoresData', listaMultiplicadoresData);
    try {
      const response = await api.post('/TabelaMultiplicadores/salvar', listaMultiplicadoresData);
      Swal.fire({
          title: "Sucesso",
          text: response.data,
          icon: "success",
          confirmButtonText: "OK",
      });
      onRequestClose();
  } catch (err) {
      console.error("Erro ao salvar multiplicadores:", err);
      Swal.fire({
          title: "Erro",
          text: "Erro ao salvar os dados. Tente novamente.",
          icon: "error",
          confirmButtonText: "OK",
      });
  }
  };

  return (
    <Modal
      isOpen={isOpen}
      onAfterOpen={onAfterOpen}
      onRequestClose={onRequestClose}
      contentLabel="PME - Tabela Multiplicadores"
      style={style}
      ariaHideApp={false}
      shouldCloseOnOverlayClick={false}
    >
      <StyledModalCicloAdd>
        <StyledForm>
          <p className="modal-close" onClick={onRequestClose}>
            X
          </p>
        </StyledForm>
        <StyledForm>
          <Flex>
            <Flex.Item className="modal-width">
              <div className="position-relative form-group">
                <p className="modal-title">
                  Tabela Multiplicadores - {perfilNome}
                </p>
              </div>
            </Flex.Item>
          </Flex>
        </StyledForm>
        <StyledForm>
          <div className="table-scroll font-0-9x table-bordered table-container">
            <table className="table table-width table-sm">
              <thead>
                <tr className="table-legend-info">
                  <th key="de">De</th>
                  <th key="ate">Até</th>
                  <th key="multiplicador">Multiplicador</th>
                </tr>
              </thead>
              <tbody>
                {listaMultiplicadoresData.map((multi) => (                  
                  <tr key={`row-multi-${multi.idPerfilsProgramasMultiplicadores}`}>
                    <td className="text-center">
                      <MemorizedDynamicInput
                        placeholder=""
                        label=""
                        name={`de-${multi.idPerfilsProgramasMultiplicadores}`}
                        paramMethod={(value) =>
                          handleInputChange(
                            multi.idPerfilsProgramasMultiplicadores,
                            "de",
                            value
                          )
                        }
                        value={multi.de}
                      />
                    </td>
                    <td className="text-center">
                      <MemorizedDynamicInput
                        placeholder=""
                        label=""
                        name={`ate-${multi.idPerfilsProgramasMultiplicadores}`}
                        paramMethod={(value) =>
                          handleInputChange(
                            multi.idPerfilsProgramasMultiplicadores,
                            "ate",
                            value
                          )
                        }
                        value={multi.ate}
                      />
                    </td>
                    <td className="text-center">
                      <MemorizedDynamicInput
                        placeholder=""
                        label=""
                        name={`multiplicador-${multi.idPerfilsProgramasMultiplicadores}`}
                        paramMethod={(value) =>
                          handleInputChange(
                            multi.idPerfilsProgramasMultiplicadores,
                            "multiplicador",
                            value
                          )
                        }
                        value={multi.multiplicador}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className='d-flex justify-content-center mt-5'>
              <div className="col-sm-3 col-md-3 col-lg-3">
                  <button type="button" className='default-button-red-small' onClick={() => saveTable()}>Salvar</button>
              </div>
          </div>
        </StyledForm>
      </StyledModalCicloAdd>
    </Modal>
  );
};
